import React from 'react'
import { CRow, CCol, CContainer, CCard, CCardBody, CCardHeader, CImage, } from '@coreui/react'
import SutLogo from '../../../assets/images/SUT512.png'

const MaintenancePage = () => {
  return (
    <div className='pages-background' style={{ minHeight: '100vh' }}>
      <CContainer className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh', padding: '40px 20px' }}>

        {/* Logo/Title Section */}
        <CCard className='card-border-radius-20 shadow-lg mb-4' style={{ maxWidth: '600px', width: '100%' }}>
          <CCardHeader className='card-header-border-radius text-center' style={{ background: 'linear-gradient(45deg, #fb9700, #ff6105)', border: 'none' }}>
            <CRow className="align-items-center justify-content-center">
              <CCol xs="auto">
                <CImage src={SutLogo} alt="SUT Logo" width="80" height="80" className="me-3" />
              </CCol>
              <CCol xs="auto">
                <h1 className='color-white mb-2' style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
                  SUT ALUMNI
                </h1>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody className="text-center p-4">
            {/* Thai Content */}
            <div className="mb-4">
              <h2 className='text-danger mb-2' style={{ fontSize: '1.5rem', fontWeight: '600' }}>
                  แจ้งปิดปรับปรุงระบบ
                </h2>
              <h3 className="text-danger mb-3" style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
                ขออภัยในความไม่สะดวกครับ
              </h3>

              <hr style={{ borderColor: '#fb9700', borderWidth: '2px', opacity: '1' }} />

              <div className="my-3">
                <p className="mb-1" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>งานศิษย์เก่าสัมพันธ์</strong>
                </p>
                <p className="mb-1" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>ส่วนกิจการนักศึกษา</strong>
                </p>
                <p className="mb-1" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>มหาวิทยาลัยเทคโนโลยีสุรนารี</strong>
                </p>
                <p className="mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>โทรศัพท์ 0-4422-3630</strong>
                </p>
              </div>

              <hr style={{ borderColor: '#fb9700', borderWidth: '2px', opacity: '1' }} />
            </div>

            {/* English Content */}
            <div>
              <h3 className="text-danger mb-3" style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>
                System Temporarily Unavailable for Maintenance
              </h3>
              <h4 className=" mb-3" style={{ fontSize: '1rem' }}>
                We apologize for any inconvenience this may cause
              </h4>

              <hr style={{ borderColor: '#fb9700', borderWidth: '2px', opacity: '1' }} />

              <div className="my-3">
                <p className="mb-1" style={{ fontSize: '1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>Section for Alumni Engagement</strong>
                </p>
                <p className="mb-1" style={{ fontSize: '1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>Division of Student Affairs</strong>
                </p>
                <p className="mb-1" style={{ fontSize: '1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>Suranaree University of Technology</strong>
                </p>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.8', color: '#333' }}>
                  <strong>Tel. 0-4422-3630</strong>
                </p>
              </div>

              <hr style={{ borderColor: '#fb9700', borderWidth: '2px', opacity: '1' }} />
            </div>
          </CCardBody>
        </CCard>

        {/* Footer */}
        <div className="text-center mt-4">
          <p className="color-white mb-0" style={{ fontSize: '0.9rem', opacity: '0.9' }}>
            © 2025 Suranaree University of Technology - Alumni System
          </p>
        </div>
      </CContainer>
    </div>
  )
}

export default MaintenancePage
